/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Save_Logistics_DetailsInputs */

const en_orders_save_logistics_details = /** @type {(inputs: Orders_Save_Logistics_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Logistics Details`)
};

const es_orders_save_logistics_details = /** @type {(inputs: Orders_Save_Logistics_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar detalles de logistica`)
};

/**
* | output |
* | --- |
* | "Save Logistics Details" |
*
* @param {Orders_Save_Logistics_DetailsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_save_logistics_details = /** @type {((inputs?: Orders_Save_Logistics_DetailsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Save_Logistics_DetailsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_save_logistics_details(inputs)
	return es_orders_save_logistics_details(inputs)
});